import React from 'react';
import './button.css';
import '../general.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faUser, faCog, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export interface LSButtonProps {
   Logo?: any;
   LogoAlt?: any;
   onClick?: () => void;
   Text: string;
   TextAlt?: string;
   ID: string;
   State?: string;
   ClassN?: string;
   Disabled?: boolean;
   MainColor?: string;
}

const LSButton = (props: LSButtonProps) => {
   const {
      Disabled = false,
      ClassN,
      onClick,
      Logo = faUser,
      TextAlt = 'Loading ...',
      LogoAlt = faCog,
      Text,
      ID,
      State = '',
      MainColor = '#069bff',
   } = props;

   const DisabledN: boolean = State !== 'loading' ? Disabled : true;

   return (
      <button
         id={ID}
         className={
            (State !== 'loading' ? 'ams-btn card-1 useFont disfirst ' : 'ams-btn card-1 loading  useFont dissecond ') +
            ClassN
         }
         onClick={onClick}
         disabled={DisabledN}
         style={{ backgroundColor: MainColor, color: '#FFF' }}
      >
         <div className="ams-btn-logo ">
            <div className="ams-btn-logo-main">
               <FontAwesomeIcon color="#FFF" icon={Logo} size="1x" />
            </div>
            <div className="ams-btn-logo-main">
               <FontAwesomeIcon color="#FFF" icon={faCircleNotch} size="1x" spin={true} />
               {/* <FontAwesomeIcon color="#FFF" icon={LogoAlt} size="1x" /> */}
            </div>
         </div>
         <div className="ams-btn-text">
            <div className="ams-btn-text-main">{Text}</div>
            <div className="ams-btn-text-main">{TextAlt}</div>
         </div>
      </button>
   );
};

export default LSButton;
